<div (scrolled)="loadNextGraphsBatch()"
     [alwaysCallback]="true"
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="300"
     infiniteScroll>
  <div *ngIf="noGraphs === false && !loadingPrefs" class="e2e-filters">
    <div class="e2e-filters-row">
      <div class="e2e-filter-field e2e-filter-field--routes">
        <label class="e2e-filter-label">Routes</label>
        <div class="e2e-filter-control">
          <p-multiSelect (onChange)="onSelect()"
                         [(ngModel)]="selectedVlan"
                         [options]="vlanListSelect"
                         [placeholder]="'Select route(s)'"
                         [maxSelectedLabels]="2"
                         filter="true"
                         optionLabel="label"
                         optionValue="value">
          </p-multiSelect>
          <button (click)="saveUserPrefs(true)" [disabled]="updateRoutesDisabled" label="Update routes" pButton
                  type="button"></button>
        </div>
      </div>
      <div class="e2e-filter-field">
        <label class="e2e-filter-label">Time zone</label>
        <div class="e2e-filter-control">
          <p-dropdown (onChange)="changeTimeZone()"
                      [(ngModel)]="selectedTimeZone"
                      [options]="graphHandlerService.timeZoneList">
          </p-dropdown>
          <p-toggleButton (onChange)="saveUserPrefs()" [(ngModel)]="zoomIn" offLabel="Zoom in"
                          onLabel="Zoom out" styleClass="e2e-zoom-toggle"></p-toggleButton>
          <button (click)="refreshGraphsData()" [disabled]="refreshingGraphs"
                  class="e2e-refresh-button" pButton pTooltip="Refresh data" tooltipPosition="top" type="button">
            <i [class.fa-spin]="refreshingGraphs" class="fa fa-refresh"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="e2e-filters-row">
      <div class="e2e-filter-field e2e-filter-field--routes">
        <label class="e2e-filter-label">Save filters as</label>
        <div class="e2e-filter-control">
          <input [(ngModel)]="selectedConfigurationName" [style]="{'width':'100%'}"
                 class="filter-name"
                 id="selectedConfigurationName"
                 pInputText
                 placeholder="Configuration name"
                 type="text">
          <button (click)="saveConfiguration()" [disabled]="!selectedConfigurationName"
                  label="Save filters"
                  pButton>
          </button>
        </div>
      </div>
      <div class="e2e-filter-field">
        <label class="e2e-filter-label">
          <ng-container *ngIf="savedUserConfigs.length > 0; else noSavedConfigsLabel">Load filters</ng-container>
          <ng-template #noSavedConfigsLabel>&nbsp;</ng-template>
        </label>
        <div class="e2e-filter-control">
          <p-dropdown *ngIf="savedUserConfigs.length > 0"
                      (onChange)="loadSavedConfiguration()"
                      [(ngModel)]="selectedConfigurationId"
                      [filter]="true"
                      [options]="savedUserConfigsList"
                      placeholder="Select configuration to load">
          </p-dropdown>
          <button (click)="resetFilters()" class="p-button-outlined e2e-reset-button" label="Reset filters"
                  pButton>
          </button>
        </div>
      </div>
    </div>
    <div class="e2e-filters-row">
      <div class="e2e-filter-field e2e-filter-field--routes">
        <label class="e2e-filter-label">Business unit</label>
        <div class="e2e-filter-control">
          <p-multiSelect
            [(ngModel)]="selectedBusinessUnit"
            (onChange)="filterbyBusinessUnit()"
            [options]="businessUnitsList"
            placeholder="Choose a business unit"
            optionLabel="label">
          </p-multiSelect>
        </div>
      </div>
    </div>
    <p *ngIf="showChangedConfigMessage" class="e2e-unsaved-warning">You have unsaved changes. All changes will be lost
      if you exit this page</p>
  </div>

  <div *ngIf="noGraphs === false" class="e2e-grid" [ngClass]="{'e2e-grid--single': zoomIn === true}">
    <ng-container *ngFor="let index of vvlans">
      <div *ngIf="(listObservable[index]) && isDisplayedData(index) && graphData[index]" class="e2e-card">
        <div class="e2e-card-header">
          <span class="e2e-card-title"
                [pTooltip]="technicalPopService.getCageTooltip(getTechnicalPopFromLabel(index))">{{ getGraphLegend(index) }}</span>
          <div class="e2e-card-actions">
            <button (click)="refreshSingleGraph(index)" [disabled]="refreshingGraphIds[index]"
                    class="e2e-action-button" pButton
                    pTooltip="Refresh this graph" type="button">
              <i [class.fa-spin]="refreshingGraphIds[index]" class="fa fa-refresh"></i>
            </button>
            <button (click)="exportCsv(index)" *ngIf="graphData[index]['datasets'].length > 0"
                    class="e2e-action-button" icon="fa fa-download" pButton
                    pTooltip="Export CSV" type="button"></button>
            <button (click)="exportPng(index)" *ngIf="graphData[index]['datasets'].length > 0"
                    class="e2e-action-button" icon="fa fa-image" pButton
                    pTooltip="Export PNG" type="button"></button>
            <button (click)="hideGraph(index)"
                    class="e2e-action-button" icon="fa fa-eye-slash" label="Hide" pButton
                    pTooltip="Hide graph" type="button"></button>
          </div>
        </div>

        <ng-container *ngIf="graphData[index]['datasets'].length > 0">
          <div class="e2e-card-toolbar">
            <div class="e2e-toolbar-field">
              <label class="e2e-filter-label">Unit</label>
              <p-dropdown (onChange)="reloadCharts(index)"
                          [(ngModel)]="graphExecutionTimeOptions[index].scales.x.time.unit"
                          [options]="zoomOptions"
                          [style]="{'minWidth':'90px'}">
              </p-dropdown>
            </div>
            <div class="e2e-toolbar-field">
              <label class="e2e-filter-label">Period</label>
              <p-selectButton (onChange)="updateTimeScale(index)" [(ngModel)]="selectedPeriod[index]"
                              [options]="periods"></p-selectButton>
            </div>
            <div class="e2e-toolbar-field">
              <label class="e2e-filter-label">&nbsp;</label>
              <button (click)="resetCharZoom(index)" class="p-button-outlined e2e-toolbar-reset"
                      label="Reset layout" pButton type="button"></button>
            </div>
          </div>

          <p-chart #chart
                   [data]="graphData[index]"
                   [id]="index"
                   [options]="graphExecutionTimeOptions[index]"
                   [plugins]="chartPlugins"
                   class="e2e-chart"
                   type="line"></p-chart>
          <div class="e2e-zoom-hint">Drag to zoom &middot; Shift + drag to pan &middot; Ctrl + scroll to zoom</div>
        </ng-container>

        <div *ngIf="graphData[index]['datasets'].length === 0" class="e2e-empty">
          <i class="fa fa-line-chart"></i>
          <span>No data available for this route</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div *ngIf="noGraphs === true">
  <h2>No Graph data to be displayed</h2>
</div>
